import config from '$config';

const buildFor = process.env.BUILD_FOR || 'maia';

// The Renault image is built with BUILD_FOR=maia-renault. Prefer that over the
// runtime segment group so this deployment never renders Motrio chrome.
export const isRenault = config.segmentGroup === 'RENAULT' || buildFor === 'maia-renault';

export const isMotrio = !isRenault && config.segmentGroup === 'MOTRIO';
